import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

// Pages
import HomePage from './pages/HomePage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminServicesPage from './pages/admin/AdminServicesPage';
import AdminProjectsPage from './pages/admin/AdminProjectsPage';
import AdminTestimonialsPage from './pages/admin/AdminTestimonialsPage';
import AdminMessagesPage from './pages/admin/AdminMessagesPage';
import NotFoundPage from './pages/NotFoundPage';
import MainLayout from './components/MainLayout';
import SubmitTestimonialPage from './pages/SubmitTestimonialPage';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
    const location = useLocation();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                width: '100%',
                justifyContent: 'space-between',
            }}
        >
            {!location.pathname.startsWith('/admin') && <Header />}
            <Box component="main" sx={{ flexGrow: 1 }}>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <MainLayout>
                                <HomePage />
                            </MainLayout>
                        }
                    />
                    <Route path="/admin/login" element={<AdminLoginPage />} />

                    {/* Protected Admin Routes */}
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute>
                                <AdminDashboardPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/services"
                        element={
                            <ProtectedRoute>
                                <AdminServicesPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/projects"
                        element={
                            <ProtectedRoute>
                                <AdminProjectsPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/testimonials"
                        element={
                            <ProtectedRoute>
                                <AdminTestimonialsPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/messages"
                        element={
                            <ProtectedRoute>
                                <AdminMessagesPage />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/submit-testimonial"
                        element={<SubmitTestimonialPage />}
                    />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </Box>
            {!location.pathname.startsWith('/admin') && <Footer />}
        </Box>
    );
}

export default App;
